import { createSelector } from '@app/utils/createSelector'
import { catchFetchDataError } from '@app/utils/performFetchData'

import { createLoadable } from '@app/packages/thunkSelector/thunkSelector'
import type { SliceState } from '@app/packages/thunkSelector/withCheckedSliceState'
import { withCheckedSliceState } from '@app/packages/thunkSelector/withCheckedSliceState'

import { createReduxSlice } from '@app/store/redux_slice'

import { academyEventDriverSelector } from './event'
import type { AcademyCourse } from './lib'
import { toCourseBundle } from './lib'

const coursesSlice = createReduxSlice<SliceState<AcademyCourse[]>>('academy_courses')

// Courses are keyed off the shared academy event driver (setAcademyEventDriver) — with no driver
// the selector yields an empty list; when the event changes the hash changes and they re-load.
export const coursesResultSelector = createSelector([coursesSlice.selector, academyEventDriverSelector], (sliceState, driver) =>
  createLoadable(c => {
    if (!driver) return EMPTY_COURSES
    return withCheckedSliceState(c, {
      sliceState,
      slice: coursesSlice,
      hash: driver.event,
      load: async dispatch => {
        const [{ getAcademyCourses }, { callV2Api }] = await Promise.all([import('@app/packages/api/v2/actions/academy'), import('@app/store/actions/api')])
        const resp = await dispatch(callV2Api(getAcademyCourses(driver.event, 3650))).catch(catchFetchDataError(dispatch, 'Academy courses fetch failed'))
        return resp.data.map(toCourseBundle)
      },
    })
  })
)

export const coursesSelector = createSelector([coursesSlice.selector], slice => slice?.data ?? EMPTY_COURSES)

const EMPTY_COURSES: AcademyCourse[] = []
